/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest } from 'redux-saga/effects';

import * as commonSagas from '../_common/commonSagas';
import * as iotSlice from './iotSlice';

export default function* watchIotSaga() {
 yield takeLatest(iotSlice.getTableStart.type, commonSagas.getTable);
 yield takeLatest(iotSlice.getItemStart.type, commonSagas.getItem);
 yield takeLatest(iotSlice.createItemStart.type, commonSagas.createItem);
 yield takeLatest(iotSlice.updateItemStart.type, commonSagas.updateItem);
 yield takeLatest(iotSlice.deleteItemsStart.type, commonSagas.deleteItems);
 yield takeLatest(iotSlice.deleteItemStart.type, commonSagas.deleteItem);
 yield takeLatest(
  iotSlice.getTableStructureStart.type,
  commonSagas.getTableStructure,
 );
 yield takeLatest(
  iotSlice.getItemDocumentsStart.type,
  commonSagas.getItemDocuments,
 );
 yield takeLatest(
  iotSlice.uploadItemDocumentsStart.type,
  commonSagas.uploadItemDocuments,
 );
 yield takeLatest(
  iotSlice.deleteItemDocumentStart.type,
  commonSagas.deleteItemDocument,
 );
 yield takeLatest(iotSlice.getTableExcelStart.type, commonSagas.getTableExcel);
}
